import PresentableError from "./PresentableError";

/**
 * Error if a a user tries to modify a deliverable that has been
 * modified in a concurrent session
 *
 * @param {string} [details] - the raw "Component blocked by ..." details string
 *   from the API response, used to resolve the blocking users.
 *
 * @constructor
 * @extends PresentableError
 *
 */
function ModifiedInConcurrentSessionError(details) {
    this.code = ModifiedInConcurrentSessionError.CODE;
    this.title = "ERROR_DELIVERABLE_MODIFIED_IN_CONCURRENT_SESSION_TITLE";
    this.message = "ERROR_DELIVERABLE_MODIFIED_IN_CONCURRENT_SESSION_MESSAGE";
    this.details = details;
}

/**
 * The API error code identifying this error, shared with the classification
 * done in errorHandler.service.js so every endpoint returning it is handled
 * the same way, without each call site needing to detect it itself.
 */
ModifiedInConcurrentSessionError.CODE =
    "ERROR_DELIVERABLE_MODIFIED_IN_CONCURRENT_SESSION";

ModifiedInConcurrentSessionError.prototype = Object.create(
    PresentableError.prototype
);

/** @inheritdoc */ ModifiedInConcurrentSessionError.prototype.preferredPresentationStyle =
    function () {
        // set as NONE as this error is handled centrally by
        // errorPresenterService, which opens the dedicated dialog instead of
        // a toast or the generic error dialog
        return PresentableError.presentationStyle.NONE;
    };

/** @inheritdoc */ ModifiedInConcurrentSessionError.prototype.shouldAutoClose =
    function () {
        return true;
    };

export default ModifiedInConcurrentSessionError;
